import React from 'react';
import { BgImage } from 'gbimage-bridge';
import { GatsbyImage } from 'gatsby-plugin-image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Container, Grid, makeStyles, Typography } from '@material-ui/core';

import { WaveUpSVG } from '../WaveSVGs/WaveUpSVG';
import { ReverseWaveDownSVG } from '../WaveSVGs/ReverseWaveDownSVG';
import PortableText from 'react-portable-text';

const useStyles = makeStyles((theme) => ({
	imgCont: {
		// zIndex: -10000,
		marginTop: '6rem',
	},
	content: {
		padding: '4rem 0',
	},
	stat: {
		color: '#FFF',
		textAlign: 'center',
		lineHeight: 1.7,
		// padding: '2rem 0',
		[theme.breakpoints.down('xs')]: {
			marginBottom: '1rem',
		},
	},
	text: {
		color: 'white',
		textAlign: 'center',

	},
}));

export const ServiceSection = ({ content, background }) => {
	const classes = useStyles();
	return (
		<>
			<BgImage
				className={classes.imgCont}
				image={background.asset?.gatsbyImageData}>
				{/* <ReverseWaveDownSVG fill='#FFF' /> */}
				<Container>
					<Grid
						// style={{ padding: roi && '10rem 0' }}
						container
						direction='column'
						justifyContent='space-evenly'
						alignItems='center'
						className={classes.content}>
						<PortableText
							content={content}
							serializers={{
								h2: ({ children }) => (
									<Typography variant='h2' className={classes.text}>
										{children}
									</Typography>
								),
								normal: ({ children }) => (
                  <Typography
                    variant='h5'
                    className={classes.text}
                    style={{ marginBottom: '2rem', fontWeight: 500, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Grid 
                      item 
                      xs={12} 
                      md={10}>
                      {children}
                    </Grid>
                  </Typography>
								),
								emailPhoneLink: (props) => {
									return (
										<a href={props.emailPhoneHref} style={{ color: 'white' }}>
											{props.children[0]}
										</a>
									);
								},
								link: (props) => {
									return (
										<a
											href={props.value.href}
											style={{ textDecoration: 'underline' }}
											target='_blank'
											rel='noreferrer'>
											{props.children[0]}
										</a>
									);
								},
							}}
						/>
					</Grid>
				</Container>
			</BgImage>
			{/* <WaveUpSVG fill='#FFF' /> */}
		</>
	);
};
